import { useQuery, useMutation, useQueryClient } from 'react-query';
import { GetFloorById, AddNewFloor, UpdateFloor, DeleteFloor, GetFloors } from '../services/backend';
import { Notify, NotifyError } from '../utils/functions';

export function useGetFloors(buildingId = 'all', filters = {}) {
    return useQuery('floors', () => GetFloors(buildingId, filters), {
        refetchOnWindowFocus: false,
        staleTime: 5 * 60 * 1000, // 5 minutes
        select: (data) => {
            return data?.data?.floors || [];
        },
        onError: (error) => {
            NotifyError("Failed to fetch floors", error);
            console.error("Error fetching floors:", error);
        }
    });
}

export function useGetFloorById(floorId) {
    return useQuery(
        ['floor', floorId],
        () => GetFloorById(floorId),
        {
            enabled: !!floorId,
            staleTime: 5 * 60 * 1000, // 5 minutes
            onError: (error) => {
                NotifyError("Failed to fetch floor details", error);
                console.error("Error fetching floor details:", error);
            }
        }
    );
}

export function useAddFloor() {
    const queryClient = useQueryClient();
    return useMutation(({ buildingId, data }) => AddNewFloor(buildingId, data), {
        onSuccess: () => {
            Notify("Floor added successfully");

            queryClient.invalidateQueries('floors');
            queryClient.invalidateQueries('buildings');
        },
        onError: (error) => {
            NotifyError("Failed to add floor", error);
            console.error("Error adding floor:", error);
        }
    });
}

export function useUpdateFloor() {
    const queryClient = useQueryClient();
    return useMutation(({ floorId, data }) => UpdateFloor(floorId, data), {
        onSuccess: () => {
            Notify("Floor updated successfully");

            queryClient.invalidateQueries('floors');
            queryClient.invalidateQueries('buildings');
        },
        onError: (error) => {
            NotifyError("Failed to update floor", error);
            console.error("Error updating floor:", error);
        }
    });
}

export function useDeleteFloor() {
    const queryClient = useQueryClient();
    return useMutation(({ floorId }) => DeleteFloor(floorId), {
        onSuccess: () => {
            Notify("Floor deleted successfully");

            queryClient.invalidateQueries('floors');
            queryClient.invalidateQueries('buildings');
        },
        onError: (error) => {
            NotifyError("Failed to delete floor", error);
            console.error("Error deleting floor:", error);
        }
    });
}